const MenuStyles = {
    Heading: { margin: '15px 0' },
    SubNavigationMenu: {
      'abyss-sub-navigation-menu-root': { padding: 0 },
      'abyss-sub-navigation-dropdown-wrapper': { paddingLeft: 0 },
      'abyss-sub-navigation-dropdown-list-container': { borderLeft: '1px solid $primary1' },
    },
  };
  
  export { MenuStyles }